"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
// Original - https://code.amazon.com/packages/CAPWebsiteFrontend/blobs/mainline/--/packages/website/src/intl/puffjToICU.js
Object.defineProperty(exports, "__esModule", { value: true });
exports.toICUMessages = void 0;
// Object.entries polyfills
const getObjectEntries = (item) => Object.keys(item).reduce((array, key) => {
    array.push([key, item[key]]);
    return array;
}, []);
// ICU plural message format: https://formatjs.io/guides/message-syntax/#plural-format
const toICUPluralMessage = (message) => `{${message.value.param}, plural,
${getObjectEntries(message.value.pluralItems)
    .map(([pluralKey, pluralMessage]) => `${pluralKey} {${pluralMessage}}`)
    .join('\n')}}`;
// ICU select message format: https://formatjs.io/guides/message-syntax/#select-format
const toICUSelectMessage = (message) => `{${message.value.param}, select,
${getObjectEntries(message.value.selectItems)
    .map(([selectKey, selectMessage]) => `${selectKey} {${selectMessage}}`)
    .join('\n')}}`;
const toICUMessage = (message) => {
    if (message && message.value && message.value.pluralItems)
        return toICUPluralMessage(message);
    if (message && message.value && message.value.selectItems)
        return toICUSelectMessage(message);
    if (message && message.value && typeof message.value === 'string')
        return message.value;
    if (typeof message === 'string')
        return message;
    throw new Error('Unrecognized message schema');
};
// Puff-J File Format: https://w.amazon.com/index.php/INTech/Panther/Architecture/PantherFileFormat/JSON
// React-intl ICU message format: https://github.com/formatjs/react-intl/blob/master/docs/Components.md#message-syntax
const toICUMessages = (puffj) => getObjectEntries(puffj.resources).reduce((prior, [messageId, message]) => ({
    ...prior,
    [messageId]: toICUMessage(message),
}), {});
exports.toICUMessages = toICUMessages;
//# sourceMappingURL=puffToICU.js.map